// Libraries
import { Flex, Skeleton, Text } from '@chakra-ui/react';
// Components
import { RatingsIcon } from '@atoms/index';
// Types
import { RatingInfoProps } from './RatingInfo.type';

/**
 * Component that renders rating information.
 * @component
 * @param {RatingInfoProps} props - The props for the RatingInfo component.
 * @param {Rating} props.rating  - The rating key, which should be one of the keys defined in the Rating enum.
 * @param {string} props.title - The title text for the rating.
 * @param {string} props.description - The description text for the rating.
 * @param {boolean} props.isLoading - The loading state for the rating. Default value false.
 * @returns {ReactElement} The RatingInfo component.
 */
export const RatingInfo = (props: RatingInfoProps) => {
  const { rating, title, description, isLoading = false } = props;
  return (
    <Flex h={{ base: 7, sm: 9 }} minW={{ base: 36, sm: 45 }} gap={{ base: 2, sm: 3 }} alignItems='center'>
      <Skeleton isLoaded={!isLoading} borderRadius='md'>
        <RatingsIcon w={{ base: 7, sm: 9 }} h={{ base: 7, sm: 9 }} rating={rating} />
      </Skeleton>
      <Flex h='full' direction='column' justifyContent='space-around' w='full'>
        <Skeleton isLoaded={!isLoading}>
          <Text fontSize={{ base: 'm', sm: 'l' }} lineHeight='none'>
            {title}
          </Text>
        </Skeleton>
        <Skeleton isLoaded={!isLoading}>
          <Text fontSize={{ base: 's', sm: 'm' }} lineHeight='none' variant='faded' whiteSpace='nowrap'>
            {description}
          </Text>
        </Skeleton>
      </Flex>
    </Flex>
  );
};
